/* eslint-disable object-shorthand */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-var */
/* eslint-disable radix */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-trailing-spaces */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable eqeqeq */
import { Component, OnInit, ViewChild } from '@angular/core';
// import { DrawerState } from 'ion-bottom-drawer';

import {
  Platform,
  LoadingController,
  AlertController,
  ModalController,
  PopoverController,
  NavController,
} from '@ionic/angular';
import { LocalStorageService } from '../services/core/local-storage.service';
import { GlobalVariable } from '../global';
import { Router } from '@angular/router';
import { UserApiService } from '../services/user-api.service';
import { DataService } from '../services/dataService/data.service';
import { LoginModalPage } from '../login-modal/login-modal.page';
import { RewardNotificationPage } from '../reward-notification/reward-notification.page';
import { UserQrPage } from '../user-qr/user-qr.page';
import { BuyGiftcardPage } from '../buy-giftcard/buy-giftcard.page';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { CONFIG } from '../services/app-config.service';
import { PickupTimePage } from '../models/pickup-time/pickup-time.page';
import { TranslateService } from '@ngx-translate/core';
import { Autoplay } from 'swiper';
// import { EventsService } from '../services/events.service';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit {
  @ViewChild('slides') slides;
  // ALi Hasan
  businessList = [];
  // ALi Hasan
  profiledata: any;
  mobile_verify: any;
  walletAlertFlag: boolean;
  homeFlag: boolean;
  punchcount: number = 0;
  reward_count: number = 0;
  count: number = 0;
  percentVal = 50;
  discount: any;
  GainFlag: any;
  discount_value: any;
  discount_text: any;
  cartflag: boolean;
  Images: any;
  user_date: any;
  user_id: any;
  month: any;
  year: any;
  slicedValue: string;

  lastname: any;
  name: any;
  value: any;
  time: any = '4000';
  points: any;
  punch = [];
  punch_limt = [];
  places: any;
  ring_image: any;
  // @ViewChild(Slides) slides: Slides;
  // @ViewChild(Content) content: Content;
  // @ViewChild('myTabs') tabRef: Tabs;

  scannedText: any;

  public buttonText: string;
  public loading: boolean;
  private eventId: number;
  public eventTitle: string;
  data: any;
  user_email: any;
  udid: any;
  barocde_image: any;
  banner: any;
  images: any;
  filterbanner: any;
  flag: boolean;
  coordinates: any;
  punch_limt_: any;
  punch_: any;
  email: any;
  today_message: any;
  punch_menu: any;
  encodedData: any;

  banner_color: any;
  gift_cards_color: any;
  my_rewards_color: any;
  order_now_color: any;
  special_offer_color: any;

  // shouldBounce = true;
  // disableDrag = true;
  // dockedHeight = 500;
  // distanceTop = 150;
  // transition: '0.25s ease-in-out';
  // drawerState = DrawerState.Bottom;
  // states = DrawerState;
  // minimumHeight = 0;
  homeSlider = {
    slidesPerView: 1.2,
    autoplay: true,
    loop: true,
    speed: 300,
    autoplayDisableOnInteraction: false,
    noSwiping: true,
    spaceBetween: 20,
  };
  homeSliderVertical = {
    slidesPerView: 2.4,
    autoplay: true,
    loop: true,
    speed: 300,
    autoplayDisableOnInteraction: false,
    noSwiping: true,
    spaceBetween: 20,
  };
  giftslides = {
    // autoplay: true,
    // loop: true,
    // speed: 300,
  };
  slideOpts = {
    slidesPerView: 2.5,
    spaceBetween: 10,
  };

  resModelSlides = {
    slidesPerView: 1.3,
    spaceBetween: 10,
    // slidesPerView: Math.floor (window.innerWidth / 298),
  };

  isloggedIn = false;
  closeCard: boolean = false;
  slidesImages = [
    {
      slideImage: 'assets/img/home1.jpg',
      text: 'tasty Pizza will make your day',
    },
    {
      slideImage: 'assets/img/hom2.jpg',
      text: 'Have a drink before you go',
    },
    {
      slideImage: 'assets/img/kababjeesSlide.jpg',
      text: 'French fries Made from fine Potatoes.',
    },
  ];
  isLocationShared = '0';
  superCategories = [];

  categories = [];
  bannerData: any;
  // Offers = [];
  message: string;
  loadingMenu: boolean = true;
  giftCards = [];
  gift: any;
  currentTime: string;
  goingToCart: boolean = false;

  // isloggedIn: any;

  sliderOptions = {
    // slidesPerView: 1.2,
    centeredSlides: true,
    speed: 1000,
    loop: true, // Enable infinite looping
    spaceBetween: 0, // Space between slides
    autoplay: {
      delay: 3000, // Time between slides (ms)
    },
  };
  
  

  // sliderOptions = {
  //   initialSlide: 0, // Start from the first slide
  //   speed: 1000, // Slide transition speed (ms)
  //   autoplay: {
  //     delay: 3000, // Time between slides (ms)
  //   },
  //   loop: true, // Loop through slides
  //   pagination: {
  //     el: '.swiper-pagination', // Connects to the pagination element in HTML
  //     clickable: true,          // Allows users to click on dots
  //   },
  // };
  constructor(
    public router: Router,
    private dataService: DataService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    // public global: GlobalVariable,

    private platform: Platform,
    private server: UserApiService,
    public globals: GlobalVariable,
    private localStorageService: LocalStorageService,
    public modalController: ModalController,
    private popoverController: PopoverController,
    public nav: NavController,
    private nativeStorage: NativeStorage,
    private translate: TranslateService //for translate // public events:EventsService,
  ) {
    //for translate
    // this.translate.setDefaultLang('en');
    // this.translate.use('ur');
    //for translate

    // this.events.publishEvent('first','Hello World');
    // this.events.publishEvent('second','Hello World from mars');
    if (this.globals.inWeb) {
      this.router.navigateByUrl('/order', { replaceUrl: true });
      // this.router.navigateByUrl('tabs/tabs/menu', { replaceUrl: true });
    }
    this.globals.checkGPSPermission();

    // this.getBusiness();
    // this.getLoginInfo();
    // this.getIsLocationShared();
  }
  // scrollEnd(e){
  // document.getElementById('tabs').style.display='flex';

  // }
  // scrollHandler(e){
  //   if(e.detail.isScrolling){
  //     document.getElementById('tabs').style.display='none';

  //   }

  // }
  ngOnInit() {
    //      this.platform.ready().then(()=>{
    //   if(this.platform.is('desktop')){
    //     this.resModelSlides.slidesPerView=4;
    //     this.slideOpts.slidesPerView=3.5;
    //   }
    // });
  }
  changeSlide(e) {
    this.slides.startAutoplay();
  }
  ionViewWillEnter(): void {
    let kiosk = JSON.parse(localStorage.getItem('kiosk'));

    if (kiosk != null) {
      this.globals.kiosk_flag = kiosk;
    }

    this.getFranchiseInfo();
    if (
      this.globals.branch_enabled == 1 &&
      this.globals.franchise_enabled == true &&
      this.globals.tempID == CONFIG.business_id
    ) {
      this.nav.navigateRoot('select-branch');
      return;
    }
    // else {
    this.getLoginInfo();
    //changed on 29-june
    // }

    // if(this.globals.kiosk_flag!=true){
    //   if(this.globals.branch_enabled==1){
    //   let savedbranchid=localStorage.getItem('activeBranch');
    //   if(savedbranchid!=null){

    //   }
    //   else{
    //     this.nav.navigateRoot(['/select-branch']);
    //   }
    // }
    // }

    if (
      !this.globals.kiosk_flag &&
      this.localStorageService.getLogin('isLogin') == 'true' &&
      this.globals.showPromoModal
    ) {
      this.reward_notification();
      this.isloggedIn = true;
    }

    // this.platform.ready().then(()=>{

    if (this.globals.superCategories.length == 0) {
      //only load menu once......
      this.getCategories();
    }
    // debugger;
    this.getTime();
    this.getPoints();
    this.getGiftCrads();
    // this.getPunches();
    // this.special_offer_banners();
    // this.getIsLocationShared();

    // })
  }
  getFranchiseInfo() {
    // this.globals.b_type=='main' &&
    let remember = localStorage.getItem('remember_branch');

    // if(remember=='true' && this.globals.franchise_enabled==1){

    // }

    // new
    //   let busIDx=localStorage.getItem('activeBranchid');
    //   if(busIDx!=null && busIDx!='null'){
    //     this.branch_enabled=1;
    // }
    // if(this.globals.branch_enabled==1){
    //   this.branch_enabled=1;

    // }
    //new
    let busID = localStorage.getItem('activeBranchid');
    if (busID != null && busID != 'null' && remember != 'true') {
      //  CONFIG.business_id=busID;
      this.globals.branch_enabled = 1;
    }
    // }
    if (
      this.globals.franchise_enabled == false &&
      this.globals.branch_enabled == 1 &&
      remember != 'true'
    ) {
      CONFIG.business_id = this.globals.tempID;

      this.getbusinessFranchise();
    } else {
      // this.getLoginInfo();
      //changed on 29-june
      // }

      // if(this.globals.kiosk_flag!=true){
      //   if(this.globals.branch_enabled==1){
      //   let savedbranchid=localStorage.getItem('activeBranch');
      //   if(savedbranchid!=null){

      //   }
      //   else{
      //     this.nav.navigateRoot(['/select-branch']);
      //   }
      // }
      // }

      if (
        !this.globals.kiosk_flag &&
        this.localStorageService.getLogin('isLogin') == 'true' &&
        this.globals.showPromoModal
      ) {
        // this.reward_notification();
        this.isloggedIn = true;
      }
      // this.platform.ready().then(()=>{

      if (this.globals.superCategories.length == 0) {
        //only load menu once......
        this.getCategories();
      }
      // this.getTime();
      this.getPoints();
      this.getGiftCrads();
      // this.getPunches();
      // this.special_offer_banners();
      // this.getIsLocationShared();

      // })
    }
  }

  getbusinessFranchise() {
    this.globals.loader();
    this.server.getBusiness('', 'main').subscribe(
      (res) => {
        this.globals.dismiss();
        if (res.status == 'true') {
          this.globals.businessData = res.results[0];
          this.setupBusiness();
        }
      },
      (err) => {
        this.globals.dismiss();
      }
    );
  }

  setupBusiness() {
    this.globals.businessName = this.globals.businessData.name;
    this.globals.businessId = this.globals.businessData.business_id;
    this.globals.qrEnabled = this.globals.businessData?.app_qr;
    if (this.globals.qrEnabled == undefined) {
      this.globals.qrEnabled = true;
    }
    this.globals.point_check = this.globals.businessData.points_enabled;
    this.globals.MenuStyle = this.globals.businessData.menu_style;

    this.globals.punch_check = this.globals.businessData.punches_enabled;
    this.globals.special_offer = this.globals.businessData.special_offer;
    this.globals.events_enabled = this.globals.businessData.events_enabled;
    this.globals.dineInEnabled = this.globals.businessData.dine_in;
    this.globals.gallery_enabled = this.globals.businessData.gallery_enabled;
    this.globals.pickup = this.globals.businessData.pickup;
    this.globals.franchise_enabled =
      this.globals.businessData.franchise_enabled;
    this.globals.b_type = this.globals.businessData.b_type;
    this.globals.latitude = this.globals.businessData.latitude;
    this.globals.longitude = this.globals.businessData.longitude;
    this.globals.menu_ready_msg = this.globals.businessData.menu_ready_message;
    this.globals.hours_operation = this.globals.businessData.hours_operation;
    this.globals.branch_enabled = this.globals.businessData.branch_enabled;
    this.globals.giftcard_enabled = this.globals.businessData.giftcard_enabled;
    this.globals.b_logo = this.globals.businessData.logo;
    this.globals.home_logo = this.globals.businessData.logo;
    this.globals.businessHost = this.globals.businessData.marketing_url[0];

    this.globals.business_name = this.globals.businessData.name;
    this.globals.business_phone = this.globals.businessData.phone;
    this.globals.business_address = this.globals.businessData.address;
    this.globals.StripId = this.globals.businessData.stripe_id;
    this.globals.order_instructions =
      this.globals.businessData.instructions_enabled;
    this.globals.pickup_timing = this.globals.businessData.pickup_timing;
    this.globals.delivery_timing = this.globals.businessData.delivery_timing;
    this.globals.business_username = this.globals.businessData.username;
    this.globals.estimated_time = this.globals.businessData.delivery_time;
    this.globals.business_discount_count = parseInt(
      this.globals.businessData.business_discount_count
    );
    this.globals.username = this.globals.businessData.username;
    this.globals.bussinessId = this.globals.businessData.business_id;
    this.globals.admin_stripe = this.globals.businessData.admin_stripe_enabled;
    this.globals.pickupsetting = this.globals.businessData.delivery_time;
    this.globals.tax = this.globals.businessData.tax;
    this.globals.deliveryCharges = this.globals.businessData.delivery_fee;
    this.globals.cardDeliveryFee = this.globals.businessData.card_delivery_fee;
    this.globals.pickup_Time = this.globals.businessData.pickup_time;
    this.globals.minimun_order = parseInt(
      this.globals.businessData.minimum_order
    );
    this.globals.availed_discount_count = parseInt(
      this.globals.businessData.customer_discount_availed_count
    );
    this.globals.paypalId = this.globals.businessData.paypal_id;
    this.globals.Timing = this.globals.businessData.hours_operation;
    this.globals.specific_delivery_day =
      this.globals.businessData.specific_delivery_day;
    this.globals.review_enabled = this.globals.businessData.review_enabled;
    this.globals.delivery_day = this.globals.businessData.delivery_day;
    this.globals.authorize_enabled =
      this.globals.businessData.authorize_enabled;
    this.globals.card_enabled = this.globals.businessData.card_enabled;
    this.globals.loyaltyEnabled = this.globals.businessData.loyalty;
    this.globals.admin_stripe_enabled =
      this.globals.businessData.admin_stripe_enabled;
    this.globals.catering_enabled = this.globals.businessData.catering_enabled;
    this.globals.catering_cart_enabled =
      this.globals.businessData.catering_cart_enabled;
    this.globals.giftcard_amount_limit =
      this.globals.businessData.giftcard_limit;
    this.globals.business_type = this.globals.businessData.business_type;
    this.globals.appointment_enabled =
      this.globals.businessData.appointment_enabled;
    this.globals.website = this.globals.businessData.website;
    this.globals.orders_enabled = this.globals.businessData.orders_enabled;
    this.globals.BusinessDiscount = parseInt(
      this.globals.businessData.discount
    );
    this.globals.ccFeeDisclaimer = this.globals.businessData.ccFeeDisclaimer;
    this.globals.tip_enabled = this.globals.businessData.tip_enabled;
    this.globals.menu_ready = this.globals.businessData.menu_ready;
    this.globals.delivery_time = this.globals.businessData.delivery_time;
    this.globals.doordashEnabled = this.globals.businessData.doordash_enabled;
    this.globals.reservationEnabled = this.globals.businessData.reservation;
    // platform fee data;
    this.globals.platformFeeEnabled =
      this.globals.businessData.platformFeeEnabled;
    this.globals.platformFeeAmount =
      this.globals.businessData.platformFeeAmount;
    this.globals.platformFeeLabel = this.globals.businessData.platformFeeLabel;
    // scheduling
    this.globals.schedule_enabled = this.globals.businessData.schedule_enabled;
    // display_menu
    this.globals.display_menu = this.globals.businessData.display_menu;

    document.getElementById('title').innerHTML = this.globals.businessData.name;

    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }

    if (this.globals.businessData.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }

    if (this.globals.businessData.cash_enabled == '1') {
      this.globals.cash_enabled = true;
    } else {
      this.globals.cash_enabled = false;
    }

    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }

    if (this.globals.businessData.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }

    if (this.goingToCart == false && this.globals.itemsInCart.length == 0) {
      this.globals.superCategories = [];
      this.globals.Homecategories = [];
    } else {
      this.goingToCart = false;
    }

     if(this.globals.inWeb==true){
       this.globals.inWeb=true;
      //  this.getCategories();
     }
    //
    // this.globals.loader();

    // this.getTime();
    this.getPoints();
    this.getGiftCrads();
    this.loadBanner();
    // setTimeout(() => {
    //   this.globals.dismiss();
    // }, 2000);
    if (this.globals.businessData.appColor) {
      this.globals.appColor = this.globals.businessData.appColor;
      document.documentElement.style.setProperty(
        '--ion-color-primary',
        this.globals.appColor
      );
    } else {
      // this.globals.appColor = '#000000'
    }

    // if(this.globals.branch_enabled==1){
    //   this.getbusiness();
    // }
  }

  loadBanner() {
    let response = this.server.LoadBanners();
    response.subscribe(
      (data) => {
        this.globals.isDataLoaded = true;

        this.globals.banner_color = data.banner_color;
        this.globals.giftCard_color = data.gift_cards_color;
        this.globals.myRewards_color = data.my_rewards_color;
        this.globals.orderNow_color = data.order_now_color;
        this.globals.specialOffer_color = data.special_offer_color;
        this.globals.themeColor = data.theme_color;
        this.globals.cash_discount = data.cash_discount;
        this.globals.banners = data.data;
        this.globals.ring_image = data.ring_image;
        this.globals.cash_discount_enabled = data.cash_discount_enabled;
        this.globals.cash_discount_percentage = data.cash_discount_percentage;
        this.globals.cash_discount_value = data.cash_discount_value;
        if (data.theme_color) {
          this.globals.appColor = data.theme_color;

          document.documentElement.style.setProperty(
            '--ion-color-primary',
            this.globals.appColor
          );
        } else {
          // this.globals.appColor = '#000000'
        }

        this.globals.cash_discount = data.cash_discount;

        this.globals.cash_discount_enabled = data.cash_discount_enabled;
        this.globals.cash_discount_percentage = data.cash_discount_percentage;
        this.globals.cash_discount_value = data.cash_discount_value;
      },
      (error) => {
        // let alert = this.alertCtrl.create({
        //     message: 'Seems like your Network is not providing service. Try recharging',
        //     buttons: ['OK']
        // })
        // alert.present();
      }
    );
  }
  refreshList(event) {
    setTimeout(() => {
      this.getTime();
      this.getPoints();
      this.getGiftCrads();
      event.target.complete();
    }, 1000);
  }
  ionViewDidEnter() {
    setTimeout(() => {
      var date = new Date();
      var day = date.getDay();

      if (this.globals.hours_operation && this.globals.hours_operation[day]) {
        var current_day = this.globals.hours_operation[day];
        this.today_message = current_day[2];
      }
    }, 2000);
  }
  ionViewWillLeave() {
    // this.globals.loading.dismiss();
  }
  gotoMenu() {
    // this.globals.Loader();
    if (this.globals.catering_enabled) {
      //catering case
      if (!this.globals.udid) {
        this.globals.loginmodal();
      } else {
        if (this.globals.itemsInCart.length > 0) {
          if (this.globals.inWeb) {
            this.router.navigate(['/order']);
          } else {
            this.router.navigate(['/tabs/tabs/menu']);
          }
        } else {
          this.showPickupModel();
        }
      }
    } else {
      //regular case

      // && this.globals.franchise_enabled == false

      let activeBranchId = localStorage.getItem('activeBranchid');
      let activeBranch = JSON.parse(localStorage.getItem('activeBranch'));

      if (this.globals.branch_enabled == 1 && !activeBranchId) {
        this.nav.navigateRoot('select-branch');
      } else {
        // this.router.navigate(['/tabs/tabs/menu']);
        if (this.globals.inWeb) {
          this.router.navigate(['/order']);
        } else {
          if (activeBranch && activeBranch?.business_id) {
            this.select(activeBranch);
          }
          this.router.navigate(['/tabs/tabs/menu']);
        }
      }
    }
  }

  select(place) {
    this.globals.tempPlace = place;
    localStorage.setItem('activeBranchid', place?.business_id);
    localStorage.setItem('activeBranch', JSON.stringify(place));
    if (this.globals.franchise_enabled == true) {
      //if franchise save selcetion
      localStorage.setItem('remember_branch', 'true');
    }

    this.globals.businessName = place.name;
    this.globals.businessData = place;
    this.globals.business_phone = place.phone;
    this.globals.bussinessId = place.business_id;
    //for branch
    CONFIG.business_id = place.business_id;
    //asda

    this.globals.business_address = place.address;
    this.globals.tip_enabled = place.tip_enabled;
    this.globals.schedule_enabled = place.schedule_enabled;
    this.globals.display_menu = place.display_menu;
    this.globals.selected_branch_name = place.name;
    this.globals.point_check = place.points_enabled;
    this.globals.punch_check = place.punches_enabled;
    this.globals.special_offer = place.special_offer;
    this.globals.events_enabled = place.events_enabled;
    this.globals.dineInEnabled = place.dine_in;

    this.globals.businessHost = place.marketing_url[0];
    //menu style
    this.globals.MenuStyle = place.menu_style;

    // this.globals.franchise_enabled=place.franchise_enabled;
    this.globals.b_type = place.b_type;
    this.globals.gallery_enabled = place.gallery_enabled;
    this.globals.giftcard_enabled = place.giftcard_enabled;
    this.globals.pickup = place.pickup;
    this.globals.latitude = place.latitude;
    this.globals.longitude = place.longitude;
    //new added
    this.globals.qrEnabled = place.app_qr;
    if (this.globals.qrEnabled == undefined) {
      this.globals.qrEnabled = true;
    }
    //new added
    this.globals.hours_operation = place.hours_operation;
    this.globals.b_logo = place.logo;
    this.globals.StripId = place.stripe_id;
    this.globals.order_instructions = place.instructions_enabled;
    this.globals.pickup_timing = place.pickup_timing;
    this.globals.delivery_timing = place.delivery_timing;
    //this.globals.business_username = place.username;
    this.globals.branchUsername = place.username;
    this.globals.estimated_time = place.delivery_time;
    this.globals.business_discount_count = parseInt(
      place.business_discount_count
    );
    this.globals.username = place.username;
    this.globals.bussinessId = place.business_id;
    this.globals.admin_stripe = place.admin_stripe_enabled;
    this.globals.pickupsetting = place.delivery_time;
    this.globals.tax = place.tax;
    this.globals.deliveryCharges = place.delivery_fee;
    this.globals.cardDeliveryFee = place.card_delivery_fee;
    this.globals.pickup_Time = place.pickup_time;
    this.globals.minimun_order = parseInt(place.minimum_order);
    this.globals.availed_discount_count = parseInt(
      place.customer_discount_availed_count
    );
    this.globals.paypalId = place.paypal_id;
    this.globals.Timing = place.hours_operation;
    this.globals.delivery_day = place.delivery_day;
    this.globals.authorize_enabled = place.authorize_enabled;
    this.globals.card_enabled = place.card_enabled;
    this.globals.admin_stripe_enabled = place.admin_stripe_enabled;
    this.globals.catering_enabled = place.catering_enabled;
    this.globals.catering_cart_enabled = place.catering_cart_enabled;
    this.globals.loyaltyEnabled = place.loyalty;
    this.globals.reservationEnabled = place.reservation;

    this.globals.giftcard_amount_limit = place.giftcard_limit;
    this.globals.business_type = place.business_type;
    this.globals.website = place.website;
    this.globals.ccFeeDisclaimer = place.ccFeeDisclaimer;
    this.globals.menu_ready = place.menu_ready;
    this.globals.specific_delivery_day = place.specific_delivery_day;
    this.globals.review_enabled = place.review_enabled;
    this.globals.appointment_enabled = place.appointment_enabled;
    this.globals.orders_enabled = place.orders_enabled;
    this.globals.BusinessDiscount = place.discount;

    // platform fee data;
    this.globals.platformFeeEnabled = place.platformFeeEnabled;
    this.globals.platformFeeAmount = place.platformFeeAmount;
    this.globals.platformFeeLabel = place.platformFeeLabel;
    // document.documentElement.style.setProperty('--ion-color-primary', this.globals.appColor);
    localStorage.setItem('branchBusinessId', this.globals.bussinessId);

    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }
    if (place.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }
    if (place.cash_enabled == '1') {
      this.globals.cash_enabled = true;
    } else {
      this.globals.cash_enabled = false;
    }
    if (this.globals.pickup == '1') {
      this.globals.pickup = true;
    } else {
      this.globals.pickup = false;
    }
    if (place.delivery == '1') {
      this.globals.delivery = true;
    } else {
      this.globals.delivery = false;
    }

    // this.globals
    this.globals.presentToast('Please wait selecting branch..', 'middle');
    this.globals.superCategories = [];
    this.globals.Homecategories = [];
    // this.globals.itemsInCart=[];
    // this.loadMap( this.globals.latitude, this.globals.longitude  )
    this.loadBanner();
    //     if ( place.appColor) {
    //      this.globals.appColor =  place.appColor;
    //        document.documentElement.style.setProperty('--ion-color-primary', this.globals.appColor);
    //  }
    document.getElementById('title').innerHTML = place.name;
  }

  async showPickupModel() {
    const modal = await this.modalController.create({
      component: PickupTimePage,
      cssClass: 'customize_pickupModel',
      breakpoints: [0, 0.5, 0.9, 1],
      initialBreakpoint: 1,
      componentProps: {},
    });
    modal.onDidDismiss().then((res) => {
      if (res.data.pickup) {
        // this.pickupTime = res.data.pickup;
        // this.convertDate(this.pickupTime);
      }
    });
    return await modal.present();
  }
  getTime() {
    this.name = this.localStorageService.getFirstName('FirstName');
    var today = new Date();
    //first time
    let time = new Date().toLocaleTimeString(['en-us'], {
      hour: '2-digit',
      minute: '2-digit',
    });
    this.currentTime = time;
    //load time after every min
    setInterval(() => {
      let time = new Date().toLocaleTimeString(['en-us'], {
        hour: '2-digit',
        minute: '2-digit',
      });
      this.currentTime = time;
    }, 1000 * 60);

    var curHr = today.getHours();
    // var t=today.getHours();
    // setTimeout(() => {
    //   t=t-1;
    //   t=t*60;
    // }, 60*1000);

    if (curHr < 12) {
      this.message = 'Good Morning';
    } else if (curHr < 18) {
      this.message = 'Good Afternoon';
    } else {
      this.message = 'Good Evening';
    }
  }
  // special_offer_banners() {
  //   // this.isDataLoaded=false;
  //   let response = this.server.special_offer_banners();
  //   response.subscribe(
  //     (data) => {
  //       // this.isDataLoaded=true;

  //       this.bannerData = data;
  //       this.Offers = this.bannerData.data;
  //     },
  //     (error) => {
  //       this.globals.presentToast('Something went wrong, try again');
  //     }
  //   );
  // }
  // goToDeals() {
  //   this.router.navigate(['my-rewards']);
  //   this.globals.activeRewardsSegment = 'deals';
  // }
  goToGiftcards() {
    if (this.isloggedIn == true) {
      this.router.navigate(['/gift-cards']);
    } else {
      this.globals.loginmodal();
    }
  }
  async openCart() {
    if (
      this.globals.itemsInCart.length > 0 &&
      this.globals.branch_enabled == 1 &&
      this.globals.franchise_enabled == false
    ) {
      //if corporate and cart has items  change business data before switch
      this.goingToCart = true;

      this.globals.businessData = this.globals.tempPlace;

      this.setupBusiness();
      this.router.navigateByUrl('new-cart');
    } else {
      this.router.navigateByUrl('new-cart');
    }
  }
  async openQRMODAL() {
    if (this.globals.isloggedIn == true) {
      const modal = await this.modalController.create({
        component: UserQrPage,
        componentProps: { data: {} },

        backdropDismiss: true,
        cssClass: 'QRModal',
        animated: true,
        swipeToClose: true,
        mode: 'ios',
        // handle: false,
      });

      await modal.present();
    } else {
      this.globals.loginmodal();
    }
  }

  getCategories() {
    console.log('appCategories','3rd call');
    if (this.globals.inWeb == true) {
      this.globals.loader();
    }

    // this.globals.isDataLoaded = false;
    console.log('calling','home'+CONFIG.business_id);
    this.server.getCategories().subscribe(
      (res) => {
        if (this.globals.inWeb == true) {
          this.globals.dismiss();
        }
        this.globals.isDataLoaded = true;
        this.globals.scrollEvents = res.restaurant.app_menu;
        this.globals.superCategories = res.super_categories;
        this.globals.superCategories.forEach((categories) => {
          categories.isAvailabe = this.checkTiming(categories?.hours_operation);
          categories.categories.forEach((category) => {
            category.isAvailabe = this.checkTiming(category?.timings);
            category.items.forEach((item) => {
              // item.background = this.getColor();
              item.isAvailabe = this.checkTiming(item.item_timings);
            });
          });
        });

        if (this.globals.superCategories.length > 0) {
          this.globals.Homecategories =
            this.globals.superCategories[0]?.categories;

          this.globals.activeSuperCatID = this.globals.superCategories[0].id;
          if (this.globals.inWeb == true) {
            this.nav.navigateRoot('/order');
          }
          this.time_change();
        }
      },
      (err) => {
        if (this.globals.inWeb == true) {
          this.globals.dismiss();
        }
        this.globals.isDataLoaded = true;
        this.globals.presentToast('Network Error, try again');
      }
    );
  }
  
  time_change() {
    var scheduled_time_ = localStorage.getItem('scheduled_time');
    if (scheduled_time_ && scheduled_time_ != 'undefined') {
      let response = this.server.date_convert(scheduled_time_);
      response.subscribe(
        (data) => {
          if (data.success == true) {
            this.globals.s_day = data.day_id + 1;
            this.globals.s_time = data.time;
          }
        },
        (error) => {
          this.globals.presentToast(
            'Something went wrong check your internet connection.'
          );
        }
      );
    } else {
    }
  }
  getLoginInfo() {
    if (this.globals.kiosk_flag) {
      return;
    }
    if (this.platform.is('cordova')) {
      this.nativeStorage
        .getItem('user')
        .then(
          (data) => {
            // this.globals.isloggedIn=true;
            this.globals.udid = data.udid;

            this.localStorageService.setFirstName('FirstName', data.firstName);
            this.localStorageService.setLastName('LastName', data.lastName);
            this.localStorageService.setEmail('Email', data.email);
            this.localStorageService.setPhone('Phone', data.phone);
            this.localStorageService.setUdId('UdId', data.udid);
            this.localStorageService.setUrl('Url', data.url);

            this.getbusiness();

            if (this.localStorageService.getTour('Tour') == 'true') {
              this.globals.isloggedIn = true;
              this.isloggedIn = true;
            }

            // this.globals.udid = data.udid;
            // this.globals.firstName = data.firstName;
            // this.globals.lastName = data.lastName;
            // this.globals.Email = data.email;
          },
          (err) => {
            this.globals.isloggedIn = false;

            this.isloggedIn = false;
            // this.global.isloggedIn = true;
            if (this.globals.guestLogin != true) {
              this.globals.loginmodal();
            }
          }
        )
        .catch((res) => {});
    } else {
      this.getbusiness();

      let login = this.localStorageService.getLogin('isLogin');
      //  this.storage.get('loginData').then((data) => {
      if (login == 'true') {
        this.isloggedIn = true;
        this.globals.isloggedIn = true;
      } else {
        this.isloggedIn = false;
        this.globals.isloggedIn = false;
      }

      // })
    }
    // this.storage.get('loginData').then((data) => {
    //   this.isloggedIn = data;
    // }

    // );
  }
  closeLocationCard() {
    this.closeCard = true;
  }

  // async getBusiness() {
  //   this.server.getBusiness()
  //     .subscribe(
  //       async (response) => {
  //         if (response.status) {
  //           this.businessList = response.results;
  //         }
  //         // else {
  //         //   const alert = await this.alertCtrl.create({
  //         //     header: 'Something Went Wrong',
  //         //     message: '',
  //         //     buttons: ['OK'],
  //         //   });
  //         //   await alert.present();
  //         // }
  //       },
  //       async (error) => {
  //        this.globals.presentToast("Something went wrong. Check your internet")
  //       }
  //     );
  // }

  goToBusinessDetail(businessData) {
    this.dataService.setData(businessData.business_id, businessData);
    this.router.navigateByUrl('business-details/' + businessData.business_id);
  }

  getbusiness() {
    this.server.getBusiness('', 'main').subscribe((res) => {
      if (res.status == 'true') {
        //setting business
        this.globals.businessData = res.results[0];
        this.globals.BusinessDiscount = parseInt(
          this.globals.businessData.discount
        );
        this.globals.business_discount_count = parseInt(
          this.globals.businessData.business_discount_count
        );

        this.globals.availed_discount_count = parseInt(
          this.globals.businessData.customer_discount_availed_count
        );
      } else {
        this.globals.BusinessDiscount = 0;
        this.globals.business_discount_count = 0;
        this.globals.availed_discount_count = 0;
      }
    });
  }

  getPoints() {
    let response = this.server.getPoints();
    response.subscribe(
      (data) => {
        if (data.status == 'error') {
          this.points = 0;
          this.globals.points_ = 0;
          // this.globals.circle_graph(this.globals.points_, 'homecircle1', 50, 7, '#ccc');
        } else {
          this.points = data.rewards[0].points;
          this.globals.points_ = Number(this.points);
          // this.globals.circle_graph(this.globals.points_, 'homecircle1', 50, 7, '#ccc');
        }
      },
      (error) => {
        this.globals.presentToast(
          'Something went wrong check your internet connection.'
        );
      }
    );
  }

  // getPunches() {
  //   let response = this.server.getpunches_menuitems();
  //   response.subscribe(
  //     (data) => {
  //       if(this.globals.superCategories.length>0){
  //         this.globals.isDataLoaded = true;
  //       }
  //       if (data.status == true) {
  //         this.punch_menu = data.items;
  //         if (this.punch_menu.length > 0) {
  //           this.punch_ = Number(this.punch_menu[0].punch_count);
  //           this.punch_limt_ = Number(this.punch_menu[0].punch_limit);
  //           this.globals.punch_ = this.punch_;
  //           this.globals.punch_limit_ = this.punch_limt_;

  //           var percent =
  //             (parseInt(this.punch_) / parseInt(this.punch_limt_)) * 100;
  //           // this.globals.circle_graph(percent, 'homecircle1', 50, 7, '#ccc');
  //         } else {
  //           this.punch_ = 0;
  //           this.punch_limt_ = 0;
  //           // this.globals.circle_graph(0, 'homecircle1', 50, 7, '#ccc');
  //         }
  //       } else {
  //         this.punch_ = 0;
  //         this.punch_limt_ = 0;
  //         // this.globals.circle_graph(0, 'homecircle1', 50, 7, '#ccc');
  //         // this.globals.presentToast(data.message)
  //       }
  //     },
  //     (error) => {
  //       this.globals.presentToast(
  //         'Something went wrong check your internet connection.'
  //       );
  //     }
  //   );
  // }
  async reward_notification() {
    let response = this.server.reward_notification();
    response.subscribe(
      async (data) => {
        if (data.status == true) {
          this.globals.notifications = data.notifications;
          this.globals.showPromoModal = false;
          const mobile_update = await this.modalController.create({
            component: RewardNotificationPage,
            componentProps: { data: data.notifications },
            mode: 'ios',
            cssClass: 'message_POP',
            swipeToClose: true,
          });
          mobile_update.present();
        }
      },
      (error) => {}
    );
  }
  // async openQRMODAL() {
  //   const modal = await this.modalController.create({
  //     component: UserQrPage,
  //     componentProps: { data: {} },

  //     backdropDismiss: true,
  //     cssClass: 'QRModal',
  //     animated: true,
  //     swipeToClose: true,
  //     mode: 'ios',
  //     // handle: false,
  //   });

  //   await modal.present();
  // }
  goToCategory(cat) {
    // this.globals.Loader();
    if (this.globals.superCategories.length == 1) {
      this.globals.selectedCategory = cat;
    } else if (this.globals.superCategories.length > 1) {
      this.globals.selectedCategory = cat;
    }

    if (this.globals.branch_enabled == 1) {
      this.nav.navigateRoot('/select-branch');
    } else {
      // this.router.navigate(['tabs/tabs/menu']);
      if (this.globals.inWeb) {
        this.router.navigate(['/order']);
      } else {
        this.router.navigate(['/tabs/tabs/menu']);
      }
    }
  }
  openReservations() {
    this.router.navigateByUrl('/reservations');
  }
  getGiftCrads() {
    // this.isDataLoaded=false;
    let response = this.server.my_gift_cards_design();
    response.subscribe(
      (data) => {
        //  this.isDataLoaded=true;
        this.giftCards = data;
        if (this.giftCards.length > 0) {
          this.gift = this.giftCards[0];
        }
      },
      (error) => {}
    );
  }
  async buyGift(banner) {
    if (this.isloggedIn != true) {
      this.globals.loginmodal();

      return;
    }

    const modal = await this.modalController.create({
      component: BuyGiftcardPage,
      componentProps: { data: { banner: banner } },
    });

    modal.present();
  }
  profilePage() {
    this.nav.navigateRoot('/profile');
  }

  checkTiming(Timing) {
    if (Timing) {
      var scheduled_time_ = localStorage.getItem('scheduled_time');
      var date: any;
      var time: any;
      var day: any;
      if (
        this.globals.order_time == 'schedule' &&
        scheduled_time_ &&
        scheduled_time_ != null
      ) {
        day = this.globals.s_day;
        time = this.globals.s_time;
      } else {
        date = new Date();
        day = date.getDay();
        time = date.getHours() + '.' + date.getMinutes();
      }

      if (day == 7) {
        day = 0;
      }

      var current_day = Timing[day];
      var n = current_day[0].indexOf('.');
      if (n != -1) {
        var res = current_day[0].split('.');
        current_day[0] = res[0] + '.' + '3';
      }
      var n1 = current_day[1].indexOf('.');
      if (n1 != -1) {
        var res = current_day[1].split('.');
        current_day[1] = res[0] + '.' + '3';
      }

      time = Number(time);
      if (current_day) {
        if (
          (Number(current_day[0]) <= time && Number(current_day[1]) > time) ||
          (Number(current_day[0]) <= time &&
            Number(current_day[1]) < Number(current_day[0]))
        ) {
          return true;
        } else if (current_day[0] == 'opened' && current_day[1] == 'opened') {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  goTo(path) {
    if (this.globals.businessId == '356') {
      this.globals.opneReview();
    } else {
      if (this.globals.isloggedIn == true) {
        this.router.navigate([path]);
      } else {
        this.globals.loginmodal();
      }
    }
  }
}
